export default __webpack_public_path__ + "static/media/cousera.7e7323b3.jpg";